import React from "react"
import PropTypes from "prop-types"

const EyeIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 17 12">
    <mask id="mask-2" fill="white">
      <polygon id="path-1" points="17 12 17 0 0 1.46968299e-15 0 12 17 12"></polygon>
    </mask>
    <path d="M11.7539655,4.46421677 C12.000543,4.92857143 12.1429513,5.44649752 12.1429513,6 C12.1429513,7.8927882 10.5111887,9.42857143 8.49989012,9.42857143 C6.48881132,9.42857143 4.85704867,7.8927882 4.85704867,6 C4.85704867,4.10700496 6.48881132,2.57142857 8.49989012,2.57142857 L8.49989012,3.99986211 C7.33315235,3.99986211 6.37475276,4.90168229 6.37475276,6 C6.37475276,7.09811087 7.33315235,7.99993105 8.49989012,7.99993105 C9.66684765,7.99993105 10.6250275,7.09811087 10.6250275,6 C10.6250275,5.67857143 10.5397583,5.37493105 10.3973499,5.10707391 L11.7539655,4.46421677 Z M15.4822959,6 C15.4822959,5.07149752 12.4273286,1.42843354 8.49989012,1.42843354 C4.57245168,1.42843354 1.51770409,5.07149752 1.51770409,6 C1.51770409,6.92850248 4.57245168,10.5713596 8.49989012,10.5713596 C12.4273286,10.5713596 15.4822959,6.92850248 15.4822959,6 Z M17,6 C17,7.97324876 13.0631116,12 8.49989012,12 C3.93688837,12 0,7.97324876 0,6 C0,4.02675124 3.93688837,0 8.49989012,0 C13.0631116,0 17,4.02675124 17,6 Z" id="Fill-1" fill="#101010" mask="url(#mask-2)"></path>
  </svg>
)

EyeIcon.propTypes = {
  style: PropTypes.object
}

export default EyeIcon



// WEBPACK FOOTER //
// ./src/components/icons/eye-icon.jsx